import React from 'react';

import { useUserBalance } from '../../../Store/Slicers/UserSlice';
import { isDefault } from '../../../utils/template';
import Loader from '../../loader/Loader';

function BalanceElement() {
    const { balance, isLoading } = useUserBalance();

    function getContent() {
        return (
            <>
                <span>
                    {isDefault() ? (
                        balance.formatted
                    ) : (
                        <>
                            <i className="fas fa-coins" /> {balance.formatted}
                        </>
                    )}
                </span>
            </>
        );
    }

    return <Loader isLoading={isLoading} elementToShow={getContent} />;
}

export default BalanceElement;
